import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      // 计算滚动进度
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const progress = scrollTop / docHeight;
      
      setScrollProgress(progress);
      
      // 滚动超过400px时显示按钮
      setIsVisible(scrollTop > 400);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 初始化

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ 
            duration: 0.2,
            ease: [0.4, 0, 0.2, 1]
          }}
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 group"
          aria-label="Scroll to top"
        >
          {/* 背景圆形进度指示器 */}
          <div className="relative w-11 h-11 md:w-12 md:h-12">
            {/* 进度环 */}
            <svg
              className="absolute inset-0 -rotate-90 w-full h-full"
              viewBox="0 0 48 48"
            >
              {/* 背景环 */}
              <circle
                cx="24"
                cy="24"
                r="22"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
                className="text-border/30"
              />
              {/* 进度环 */}
              <circle
                cx="24"
                cy="24"
                r="22"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
                strokeDasharray={`${2 * Math.PI * 22}`}
                strokeDashoffset={`${2 * Math.PI * 22 * (1 - scrollProgress)}`}
                className="text-primary/60 transition-all duration-150"
              />
            </svg>
            
            {/* 按钮主体 */}
            <div className="absolute inset-0.5 flex items-center justify-center rounded-full bg-background border border-border/50 shadow-sm group-hover:border-border group-hover:shadow-md transition-all duration-300">
              <ArrowUp className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors duration-300" />
            </div>
          </div>
          
          {/* 悬停时的提示文字 */}
          <motion.span
            initial={{ opacity: 0, x: 10 }}
            whileHover={{ opacity: 1, x: 0 }}
            className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-2 py-1 text-xs text-muted-foreground bg-background border border-border rounded-md whitespace-nowrap pointer-events-none hidden md:block"
          >
            Back to top
          </motion.span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}